import { render } from "./ThemeSettings.vue?vue&type=template&id=1d9bec3a&scoped=true"
import script from "./ThemeSettings.vue?vue&type=script&lang=js"
export * from "./ThemeSettings.vue?vue&type=script&lang=js"

import "./ThemeSettings.vue?vue&type=style&index=0&id=1d9bec3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9bec3a"]])

export default __exports__